export const environment = {
  production: true,
  blockManagerLogin: false,
  appApiVersion: 1,
  appVersionNumber: '2.2.6',
  appLanguageVersion: '1.0',
  platform: 'website', // website, mobile

  forceRedirectToWWW: true,
  languageLoadStrategy: 'api', // 'file' : 'api'
  websiteUrl: 'https://www.alchemistlearningjourney.com',
  adminUrl: 'https://my721.com',
  appApiUrl: 'https://www.alchemistlearningjourney.com/api2/',
  appServerApiUrl: 'https://my721.com/api2/',
  appNApiUrl: 'https://www.alchemistlearningjourney.com/napi/',
  appNApiSocketUrl: 'https://www.alchemistlearningjourney.com/',

  zoomSdkKey: 'FOnBArNTSJ63lWiP75YKGw',

  appVersionSuffix: '',
  defaultLanguage: 'en',
  firebaseConfig: {
    apiKey: 'AIzaSyBAC79IQCUZg7s8KxXfK9uGAnAghuFEDd0',
    authDomain: 'journey-app-ffc6e.firebaseapp.com',
    databaseURL: 'https://journey-app-ffc6e.firebaseio.com',
    projectId: 'journey-app-ffc6e',
    storageBucket: 'journey-app-ffc6e.appspot.com',
    messagingSenderId: '442936206687',
    appId: '1:442936206687:web:4fc31adbee8d501aa642ea',
    measurementId: 'G-05WMBYGM7E'
  },
  msalClientId: '81619d8d-fb05-4294-8bfc-d0c0f7d7d233',
  msalRedirectUri: 'https://www.alchemistlearningjourney.com/login/auth',
  oktaEnabled: false,
  oktaDomain: 'https://alchemist.uk.auth0.com',
  oktaClientId: 'jAgddd7KbD1v7KLTHrEfHdJHI9qL58iJ',
  oktaOrganization: {
    alchemist: {
      organization: 'org_VxK3POhrrxNCyjXF',
      connection: 'alchemist-saml',
    },
    jazz: {
      organization: 'org_0N0R3xYogFVQZ4GY',
      connection: 'jazz-pharmaceuticals-saml',
    },
    macmillan: {
      organization: 'org_czeP2PID61HZVibU',
      connection: 'macmillan-saml',
    }
  },
  openviduServerUrl: 'https://openvidu-ep.e-telegence.com.ua', //'https://localhost:4443',
  openviduSecret: '2H8_s3haAn',
  theme: 'default', // default, veeam
  veeam: {
    clientId: 99,
    msGraphUrl: 'https://graph.microsoft.com/v1.0/',
    teamId: '881b5205-aa89-460f-b4c5-ed2c887f2801',
    channelId: '19:c2948a9efaa54730905befcb94c032af@thread.tacv2',
  }
};
